import React from "react";
import Select, { components } from "react-select";
import { FaChevronDown, FaTimes } from "react-icons/fa";

// Optional: Custom single value display with image
const SingleValue = ({ data, ...props }) => (
  <components.SingleValue {...props}>
    <div className="flex items-center gap-2">
      {data.image && (
        <img src={data.image} alt={data.label} className="w-5 h-5" />
      )}
      <span>{data.label}</span>
    </div>
  </components.SingleValue>
);

// Custom dropdown arrow icon
const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <FaChevronDown className="text-customGreen" />
  </components.DropdownIndicator>
);

// Custom remove icon for multi-value
const MultiValueRemove = (props) => (
  <components.MultiValueRemove {...props}>
    <div className="bg-white rounded-full p-1 ">
      <FaTimes className="text-green-600 text-xs" />
    </div>
  </components.MultiValueRemove>
);

// Custom styles
const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled ? "#F3F4F6" : "#fff", // gray when disabled
    borderColor: state.isDisabled
      ? "#D1D5DB" // light gray border
      : state.isFocused
      ? "#10B981"
      : "#D1D5DB",
    color: state.isDisabled ? "#9CA3AF" : "#111827", // gray text
    boxShadow: state.isFocused ? "0 0 0 1px #10B981" : "none",
    padding: "4px 8px",
    borderRadius: "0.5rem",
    minHeight: "42px",
    cursor: state.isDisabled ? "not-allowed" : "default", // 👈 block pointer
    "&:hover": {
      borderColor: state.isDisabled ? "#D1D5DB" : "#10B981",
    },
  }),
  
  placeholder: (base) => ({
    ...base,
    color: "#9CA3AF",
    fontSize: "0.875rem",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#ECFDF5", // light green background
    borderRadius: "20px",
    border: "1px solid #399e76",
    padding: "2px 6px",
    display: "flex",
    alignItems: "center",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "",
    fontWeight: 500,
  }),
  multiValueRemove: (base) => ({
    ...base,
    backgroundColor: "transparent",
    borderRadius: "50%",
    padding: "0",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#D1FAE5",
      color: "#065F46",
    },
  }),
  option: (base, state) => ({
    ...base,
    display: "flex",
    alignItems: "center",
    backgroundColor: state.isFocused ? "#ECFDF5" : "#fff",
    color: "#111827",
    padding: "8px 12px",
    cursor: "pointer",
  }),
  singleValue: (base) => ({
    ...base,
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 100, 
    borderRadius: "0.5rem",
    overflow: "hidden",
  }),
  
};

const CustomSelect = ({
  options = [],
  value,
  onChange,
  isMulti = false,
  onInputChange,
  isClearable = true,
  placeholder = "Select option",
  className = "",
  disabled = false,
  dropdownHeight="300px",
}) => {

  const dynamicStyles = {
    ...customStyles,
    menuList: (base) => ({
      ...base,
      maxHeight: dropdownHeight,
      overflowY: 'auto',
    }),
  };
  return (
    <Select
      className={`w-full ${className}`}
      isMulti={isMulti}
      isClearable={isClearable}
      value={value}
      isDisabled={disabled}
      onChange={onChange}
      options={options}
      onInputChange={onInputChange}
      placeholder={placeholder}
      components={{ DropdownIndicator, SingleValue, MultiValueRemove }}
      formatOptionLabel={(e) => (
        <div className="flex items-center gap-2">
          {e.image && (
            <img src={e.image} alt={e.label} className="w-5 h-5 " />
          )}
          <span className="text-sm font-medium">{e.label}</span>
          {e.role && (
            <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
              {e.role}
            </span>
          )}
        </div>
      )}
styles={dynamicStyles}
    />
  );
};


export default CustomSelect;
